// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"befae8e6","533":"a1b503fb","540":"befae8e6"}[chunkId] + ".chunk.css";
};